import { setHours, setMinutes, setSeconds, setMilliseconds, format, addYears, 
  setMonth, setDate, parseISO, set,  getYear, getMonth } from 'date-fns';

export const convertNumberToWord = {
  one: 1,
  two: 2,
  three: 3,
  four: 4,
  five: 5,
  six: 6,
  seven: 7,
  eight: 8,
  nine: 9,
  ten: 10,
  eleven: 11,
  twelve: 12,
  thirteen: 13,
  fourteen: 14,
  fifteen: 15,
  sixteen: 16,
  seventeen: 17,
  eighteen: 18,
  nineteen: 19,
  twenty: 20,
  null: null,
};

export const placeholderName = (name) => {
  return name?.split(" ")?.slice(0, 2)?.map((e) => e.charAt(0).toUpperCase())?.join("") || "";
}

export function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

export const makeFilterParams = (list = [], checkPlatformKey = false) => {
  const queryParams = {
    tagIds: [],
    platforms: [],
  };
  list.forEach((filter) => {
    if (checkPlatformKey && filter?.type === "platform") {
      queryParams.platforms.push((filter.name).replace(/\s+/g, "").toLowerCase());
    } else {
      queryParams.tagIds.push(filter.value);
    }
  });
  return queryParams;
};

export const toggleArrayByObject = (array, newItem, key = "id") => {
  const index = array.findIndex((item) => item[key] == newItem[key]);
  if (index !== -1) {
    return array.filter((item) => item[key] != newItem[key]);
  } else {
    return [...array, newItem];
  }
};

export const toggleArraySingleValue = (array, id) => {
  if (array.includes(id)) {
    return array.filter((item) => item != id);
  } else {
    return [...array, id];
  }
};

export const checkDataInList = (list, data, key = "id") => {
  return list.find(item => item[key] === data[key]) ? true : false
}

export const convertStringToISODate = (date) => {
  return date ? new Date(date) : null
}

export const getFinancialYears = (fromYear) => {
  const now = new Date();
  const currentYear = getYear(now);
  const currentMonth = getMonth(now); // 0 = Jan, 3 = Apr
  const currentFinancialYearEnd = currentMonth < 3 ? currentYear : currentYear + 1;

  const financialYears = [];

  for (let year = parseInt(fromYear); year < currentFinancialYearEnd; year++) {
    const nextYear = year + 1;
    const label = `${year}-${String(nextYear).slice(-2)}`; 
    const startDate = set(new Date(), {
      year,
      month: 2, // March
      date: 31,
      hours: 18,
      minutes: 30,
      seconds: 0,
      milliseconds: 0
    });

    const endDate = set(new Date(), {
      year: nextYear,
      month: 2, // March
      date: 31,
      hours: 18,
      minutes: 29,
      seconds: 59,
      milliseconds: 999
    });

    financialYears.push({
      key: year,
      label,
      startDate: format(startDate, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
      endDate: format(endDate, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX")
    });
  }

  return financialYears;
  }
  
export const getCurrentFinancialYear = () => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth(); // 0 = Jan, 1 = Feb, ..., 11 = Dec

  const startYear = currentMonth < 3 ? currentYear - 1 : currentYear;
  const endYear = startYear + 1;
  const label = `${startYear}-${String(endYear).slice(-2)}`;

  let startDate = new Date(startYear, 2, 31);
  startDate = setHours(startDate, 18);
  startDate = setMinutes(startDate, 30);
  startDate = setSeconds(startDate, 0);
  startDate = setMilliseconds(startDate, 0);

  let endDate = new Date(endYear, 2, 31);
  endDate = setHours(endDate, 18);
  endDate = setMinutes(endDate, 29);
  endDate = setSeconds(endDate, 59);
  endDate = setMilliseconds(endDate, 999);

  const formattedStartDate = format(startDate, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX");
  const formattedEndDate = format(endDate, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX");

  return {
    key: startYear,
    label,
    startDate: formattedStartDate,
    endDate: formattedEndDate
  };
  }
  
export const formatToEncodedISOString = (date) => {
    const tzOffset = -date.getTimezoneOffset();
    const hours = String(Math.floor(Math.abs(tzOffset) / 60)).padStart(2, '0');
    const minutes = String(Math.abs(tzOffset) % 60).padStart(2, '0');
    const iso = date.toISOString().replace('Z', '');
    return iso + `+${hours}:${minutes}`;
  }
